import { updateProcess, principles } from "@/mocks/site";

export default function ProcessSection() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-8 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
          <div>
            <span className="text-xs font-semibold tracking-[0.2em] text-accent-600">
              METHOD
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              一条时间线是怎么做出来的
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              我们不生产结论，只负责把公开信息按时间摆好。每个节点都保留发布主体与来源类型，方便你自己判断。
            </p>

            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {principles.map((item) => (
                <div
                  key={item.title}
                  className="rounded-lg border border-background-200 bg-background-100/60 p-4"
                >
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <h3 className="mt-3 font-heading text-sm font-bold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative pl-6">
            <div className="absolute left-2 top-2 bottom-2 w-px bg-background-300"></div>
            <div className="flex flex-col gap-8">
              {updateProcess.map((step) => (
                <div key={step.step} className="relative">
                  <span className="absolute -left-6 top-0 flex h-4 w-4 items-center justify-center">
                    <span className="h-4 w-4 rounded-full border-2 border-accent-500 bg-background-50"></span>
                  </span>
                  <div className="flex items-baseline gap-3">
                    <span className="font-heading text-2xl font-bold text-background-300">
                      {step.step}
                    </span>
                    <h3 className="font-heading text-lg font-bold text-foreground-950">
                      {step.title}
                    </h3>
                  </div>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}